/* eslint-disable */

import request from '@/utils/request'

export function getTravellerListApi(query) {
  return request({
    url: '/config-service/v1/traveller/list',
    method: 'get',
    params: query
  })
}

export function getTravellerExcelApi(query) {
  return request({
    url: '/config-service/v1/traveller/to-excel',
    method: 'get',
    params: query,
    // responseType: 'arraybuffer'
    responseType: 'blob'
  })
}

export function getTravellerByIdApi(query) {
  return request({
    url: `/config-service/v1/traveller/${query.id}`,
    method: 'get'
  })
}

export function addTravellerApi(data) {
  return request({
    url: '/config-service/v1/traveller/insert',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getMergeProfileApi(data) {
  return request({
    url: '/config-service/v1/traveller/get-merge-profile',
    method: 'post',
    data
  })
}

export function updateTravellerApi(data, id) {
  return request({
    url: `/config-service/v1/traveller/update/${id}`,
    method: 'put',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function mergeTravellerProfileApi(data) {
  return request({
    url: '/config-service/v1/traveller/merge-profile',
    method: 'put',
    data
  })
}

export function deleteTravellerApi(data) {
  return request({
    url: '/config-service/v1/traveller/delete-ids',
    method: 'delete',
    data
  })
}

export function getTravellerNoteApi(data) {
  return request({
    url: `/config-service/v1/traveller/${data.id}/notes`,
    method: 'get',
    params: data
  })
}

export function findDuplicateTraveller(email, name, phoneNumber) {
  return request({
    url: `/config-service/v1/traveller`,
    method: 'get',
    params: { email, name, phoneNumber }
  })
}
